export const referralsTexts = {
  dashboard: {
    greeting: (name: string) => `Bonjour ${name}`,
    subtitle: 'Suivez ici les utilisations de vos codes de parrainage.',
    loadError: 'Impossible de charger vos codes de parrainage.',
    retry: 'Réessayer',
    noCodes: "Aucun code de parrainage n'est associé à votre compte pour le moment.",
  },
  code: {
    inactiveBadge: 'Code désactivé',
    trackingCode: 'Aucune réduction — code de suivi',
    monthlyDiscount: (price: string) => `1er paiement à ${price} (mensuel)`,
    quarterlyDiscount: (price: string) => `1er paiement à ${price} (trimestriel)`,
    annualDiscount: (price: string) => `1er paiement à ${price} (annuel)`,
    /** "Locatif — " prefix when the code is priced on several offers. */
    offerPrefix: (offer: string) => `${offer} — `,
    /** "puis 1 090 €/mois" — recurring months-2+ price sub-line. */
    thenRecurring: (price: string) => `puis ${price}/mois`,
    stats: {
      totalUsages: 'Utilisations totales',
      activeUsages: 'Abonnements actifs',
    },
    createdAt: (date: string) => `Créé le ${date}`,
  },
  usages: {
    empty: 'Aucune utilisation pour le moment.',
    columns: {
      name: 'Nom',
      email: 'Email',
      plan: 'Formule',
      status: 'Statut',
      date: 'Date',
    },
    plan: {
      MONTHLY: 'Mensuel',
      QUARTERLY: 'Trimestriel',
      ANNUAL: 'Annuel',
    },
    status: {
      ACTIVE: 'Actif',
      CANCELLED: 'Annulé',
      EXPIRED: 'Expiré',
      SUSPENDED: 'Suspendu',
    },
  },
}
